// extracted by mini-css-extract-plugin
export default {"main":"Results_main__h9jXP","ltr":"Results_ltr__9aU9f","rtl":"Results_rtl__TdHNq","first":"Results_first__hNQ77","uploadPdf":"Results_uploadPdf__2IeGd"};